import { render, staticRenderFns } from "./StayDoctor.vue?vue&type=template&id=7cec5dcb&"
import script from "./StayDoctor.vue?vue&type=script&lang=ts&"
export * from "./StayDoctor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cec5dcb')) {
      api.createRecord('7cec5dcb', component.options)
    } else {
      api.reload('7cec5dcb', component.options)
    }
    module.hot.accept("./StayDoctor.vue?vue&type=template&id=7cec5dcb&", function () {
      api.rerender('7cec5dcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/v2/StayDoctor.vue"
export default component.exports